<template>
    <div>
        <StationList />
    </div>
</template>

<script>
    import StationList from '../components/StationList';

    export default {
        components: {
            StationList,
        }
    };
</script>
